import React, { useState } from "react";
import { Container, Typography, TextField, Select, MenuItem, Button, FormControl, InputLabel } from "@mui/material";

const WelcomePage = () => {
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState("");

  const handleSubmit = () => {
    if (email && userType) {
      alert(`Welcome! Email: ${email}, User Type: ${userType}`);
    } else {
      alert("Please enter an email and select a user type.");
    }
  };

  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "50px" }}>
      <Typography variant="h4" gutterBottom>
        Welcome to Our Platform
      </Typography>
      <TextField
        label="Enter Your Email"
        variant="outlined"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <FormControl fullWidth margin="normal">
        <InputLabel>Select User Type</InputLabel>
        <Select value={userType} onChange={(e) => setUserType(e.target.value)}>
          <MenuItem value="homeowner_sell">🏡 Homeowner Selling</MenuItem>
          <MenuItem value="investor">💰 Investor</MenuItem>
          <MenuItem value="agent">📈 Real Estate Agent</MenuItem>
          <MenuItem value="ugly_house">🤪 Ugly House Contest</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginTop: "20px" }}>
        Submit
      </Button>
    </Container>
  );
};

export default WelcomePage;
